import { TILE_SIZE } from '@veriverse/shared';

/** Minimum number of tiles that must fit on screen (spec §9.2). */
export const MIN_VISIBLE_TILES = { width: 20, height: 12 } as const;

/**
 * Largest integer zoom that still shows at least `MIN_VISIBLE_TILES`.
 * Integer zoom keeps every pixel square: no blurry or uneven pixel art.
 */
export function integerZoom(viewportWidth: number, viewportHeight: number): number {
  const byWidth = viewportWidth / (MIN_VISIBLE_TILES.width * TILE_SIZE);
  const byHeight = viewportHeight / (MIN_VISIBLE_TILES.height * TILE_SIZE);
  return Math.max(1, Math.floor(Math.min(byWidth, byHeight)));
}
